import { render, staticRenderFns } from "./setMealDialog.vue?vue&type=template&id=67038709&scoped=true"
import script from "./setMealDialog.vue?vue&type=script&lang=js"
export * from "./setMealDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67038709",
  null
  
)

export default component.exports